import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as EnterOTP } from '../../../Assets/Images/otpEnter.svg';
import { useNavigate } from 'react-router-dom';
import { getOtp, scanCouponRegister, validateOtp } from '../../../Services/action.js';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import OtpInputBox from './OtpInputBox';
import AppTracking from '../../../Components/appTracking.js';
import { DataContext } from '../../../Components/DataContext.js';


const Enterotppage = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [wrongOTPCount, setWrongOTPCount] = useState(5);
  const { data, setData } = useContext(DataContext);
  const newData = { ...data };
  const mobileNum = newData.mobileNumber;



  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [clearOtp, setClearOtp] = useState(false);


  const [seconds, setSeconds] = useState(180);

  const formattedTime = `${Math.floor(seconds / 60)}:${seconds % 60 < 10 ? '0' : ''
    }${seconds % 60}`;

  const [loader, setLoader] = useState(false);

  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModalWarning, setIsModalWarning] = useState(false);


  const [modal, setModal] = useState('');





  const handleClose = (type) => {
    if (type === 1) {
      setIsModalSuccess(false);

      scanCouponRegister({ mobileNo: mobileNum, couponCode: newData.couponCode }).then(data => {
        if (data.statusMsg.code !== -1) {
          if (data.statusMsg.code == 0) {
            newData.couponCheck = true
          }
          else {
            newData.couponCheck = false;
          }
          newData.couponCheckCode = data.statusMsg.code;
          newData.couponCheckMsg = data.statusMsg.msg;
          if (newData.userType === 'new') {
            setData(newData);
            navigate('/registration')
          }
          else {
            newData.token = newData.tokenData;
            setData(newData);
            navigate('/dashboard')
          }
        }
        setSeconds(0);
        setClearOtp(true)
        setOtp('');
        setModal(data.statusMsg.msg)
        setIsModalError(true);
      })
        .catch(error => {
        });
    }
    else if (type === 2) {
      setIsModalError(false);
      navigate(-1);
    }
    else {
      setIsModalWarning(false);
      setClearOtp(false);
      setOtp('');
    }
  }

  const onVerify = async () => {
    setLoader(true);
    validateOtp({
      mobileNo: +mobileNum,
      otp: +otp,
    })
      .then((data) => {
        if (data.status.status === 'Y' && data.statusMsg.code === 0) {
          newData.tokenData = data.data.token;
          setData(newData);
          setLoader(false);
          setModal(data.statusMsg.msg)
          setIsModalSuccess(true);
        } else if (data.status.status === 'N' && data.statusMsg.code === 1) {
          setLoader(false);
          let c = wrongOTPCount - 1;
          setWrongOTPCount(c)
          setClearOtp(true);
          setModal(data.statusMsg.msg);
          setIsModalWarning(true);
        } else {
          setLoader(false);
          setModal(data.statusMsg.msg);
          setIsModalError(true);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  };
  function hideFirstSixDigits(mobileNum) {
    // Check if mobileNum is not empty and has at least six digits
    if (mobileNum && mobileNum.length >= 6) {
      // Replace the first six characters with asterisks
      return '******' + mobileNum.substring(6);
    } else {
      // If mobileNum is empty or has less than six digits, return it as is
      return mobileNum;
    }
  }
  let hiddenMobileNum = hideFirstSixDigits(mobileNum);
  const getResendOtp = () => {
    getOtp(mobileNum).then(() => setSeconds(180));
    setClearOtp(true)
    setIsDisabled(false);
    setOtp('');
  };
  const handleOtpChange = (otps) => {
    setOtp(otps.join('')); // Convert array of digits to string
    setClearOtp(false);
  };

  useEffect(() => {
    if (newData.couponCode == null) {
      navigate('/');
    }
    else {
      if (newData.token == null && newData.tokenData != null && newData.registration) {
        navigate('/')
      }
      else if (newData.token != null) {
        navigate('/dashboard')
      }
    }



    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(myInterval);
        setIsDisabled(true);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);


  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />

      <div className='content-wrapper responsive-wrapper'>
        <div className='row'>
          <div className='col-lg-4 col-md-4 col-sm-12 m-auto'>
            <div className='DarkPanel'>
              <div className='col-12'>
                <EnterOTP />
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <div className='OTPtime pt-4'>
                  <p>
                    We have sent an OTP to your Mobile Number <br />{' '}
                    <span>
                      {hiddenMobileNum}
                    </span>{' '}
                  </p>
                  <div className='Timer pt-1'>
                    {wrongOTPCount > 0 && wrongOTPCount < 5 && (
                      <p>{wrongOTPCount + ' attempts left'}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-sm-12'>
                <div className='Timer pt-1'>
                  <p>{formattedTime}</p>
                </div>
              </div>
            </div>
            <section className='OTP-Panel py-3'>
              <div className='row'>
                <OtpInputBox length={6} onOtpChange={handleOtpChange} clearOTP={clearOtp} disabled={isDisabled} />
              </div>

              <div className='pt-3'>
                {seconds <= 165 && (
                  <p>
                    Didn't receive OTP yet?
                    <a href='#' onClick={getResendOtp}>
                      {' '}
                      Resend OTP
                    </a>
                  </p>
                )}
              </div>
            </section>
            <div>
              <button
                type='submit'
                id='otpBtn'
                className='btn btn-primary'
                onClick={onVerify}
                disabled={seconds === 0 || otp.length < 6}
              >
                Verify
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal className="success" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalSuccess} onHide={() => handleClose(1)} >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/accept.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(1)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal className="error" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalError} onHide={() => handleClose(2)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/cross.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(2)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal >
      <Modal className="alert" aria-labelledby="contained-modal-title-vcenter"
        centered show={isModalWarning} onHide={() => handleClose(3)}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="text-center">
                <img className="image-width" src={require('../../../Assets/Images/caution.png')} alt="fireSpot" />
              </div>
              <p>
                {modal}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="" onClick={() => handleClose(3)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {loader && (
        <div id="overlay">
          <span className="loader"></span>
        </div>
      )}

    </>
  );
};

export default Enterotppage;
